import React from "react";
import "./DashboardLayout.css";

const DashboardLayout = ({ children }) => {
  return (
    <div className="layout-dashboard">
      {children}
    </div>
  );
};

export default DashboardLayout;
